import React, { useSyncExternalStore } from 'react';

import { Card } from 'core/components/card';
import { Label } from 'core/components/label';
import Switch from 'core/components/switch';
import { POCS, isPocEnabled, setPocEnabled } from 'core/pocs';
import { subscribeToPocChanges } from 'core/pocs/poc-storage';
import useStyles from './pocs.styles';

const snapshotEnabledPocs = () =>
  POCS.filter(({ key }) => isPocEnabled(key))
    .map(({ key }) => key)
    .join(',');

/**
 * Lists the proof-of-concept features deployed to this environment with a per-browser switch
 * for each. Everything starts off; see core/pocs for how a POC registers and checks its switch.
 */
const Pocs = () => {
  const classes = useStyles();
  const enabledPocs = useSyncExternalStore(subscribeToPocChanges, snapshotEnabledPocs).split(',');

  return (
    <div className={classes.container}>
      <Label type="title" className={classes.title}>
        POCs
      </Label>
      <Label type="infoValue" className={classes.subtitle}>
        Try proofs of concept (POCs) before they ship. Your choices apply only in this browser.
      </Label>
      {POCS.length === 0 ? (
        <Label type="infoValue">There are no POCs in this environment.</Label>
      ) : (
        POCS.map(({ key, name, description, reloadOnChange }) => (
          <Card key={key} type="primary" className={classes.poc}>
            <Switch
              id={`poc-${key}`}
              label={<Label type="infoValueBold">{name}</Label>}
              className={classes.pocSwitch}
              value={enabledPocs.includes(key)}
              onChange={(event) => {
                setPocEnabled(key, event.target.checked);
                if (reloadOnChange) {
                  window.location.reload();
                }
              }}
            />
            <Label type="infoValue" className={classes.description}>
              {description}
            </Label>
          </Card>
        ))
      )}
    </div>
  );
};

export default Pocs;
